(function (scope) {

scope.PageHashAnchors = function (options) {
	var me = this;
	me._options = options;
	/*
	options = {
		isUpdateURLHashOnScroll: true/false - if true, then URL is updated with hash section ids on scroll
	}
	*/
	me.init = function () {
		$(document).on ("click.PageHashAnchors", "a", function (event) {
			var hash = $(this).attr ("href");
			hash = hash.split (window.location.pathname).join ("");
			hash = hash.split (window.location.search).join ("");
			// var href2 = $(this).prop ("href");
			// var href3 = $(this)[0].getAttribute ("href");;
			// console.log (href);
			// console.log (href2);
			// console.log (href3);
			if (hash.indexOf ("#") == 0) {
				// alert ("PageHashAnchors a.click " + href);
				// alert ("!");
				me.scrollToAnchor.apply (me, [hash]);
				event.preventDefault ();
				return false;
			}
		});
		me.initScroll ();
		$(document).ready (function () {
			me.scrollToAnchor.apply (me);
		});
	};
	me._scrollInited;
	me.initScroll = function () {
		if (me._options.isUpdateURLHashOnScroll && !me._scrollInited) {
			me._scrollInited = true;
			$(window).on ("scroll.PageHashAnchors", function () {
				me.updateHash.apply (me);
			});
		}
	}
	me.disableScroll = function () {
		if (me._scrollInited) {
			me._scrollInited = false;
			$(window).off ("scroll.PageHashAnchors");
		}
	};
	me.scrollToAnchor = function (anchorName) {
		me.disableScroll ();
		if (!anchorName) {
			anchorName = window.location.hash;
		}
		if (anchorName.indexOf ("#") == 0) {
			anchorName = anchorName.substr (1);
		}
		// console.log ("PageHashAnchors.scrollToAnchor", anchorName);
		if (anchorName) {
			var anchor = $("a[name='" + anchorName + "']");
			if (!anchor.length) anchor = $("a[id='" + anchorName + "']");
			window.jpm = anchor;
			// console.log ("PageHashAnchors.scrollToAnchor " + anchorName + " " + anchor.length);
			if (anchor.length) {
				var scrollTo = $(anchor).offset ().top;
				var scrollObject = {
					scrollTop: $(window).scrollTop ()
				};
				// console.log ("PageHashAnchors.scrollToAnchor scrollTo", scrollTo, scrollObject);
				TweenMax.to (scrollObject, window.tweenDurationQuick, {
					scrollTop: scrollTo,
					onUpdate: function () {
						// console.log (this.target.scrollTop);
						// if ($("html").hasClass ("is-ie")) {
							$(window).scrollTop (this.target.scrollTop);
						// } else {
						// 	$("body").scrollTop (this.target.scrollTop);
						// }
					// },
					// onComplete: function () {
					// 	window.location.path = window.location.pathname + "#" + anchorName;
					},
					onComplete: function () {
						// console.log ("scrollToAnchor complete!");
						me.initScroll.apply (me);
					}
				});
			} else {
				me.initScroll ();
			}
		} else {
			me.initScroll ();
		}
	};
	me._updateHashTimeout;
	me._lastHash;
	me.updateHash = function () {
		// console.log ("updateHash");
		clearTimeout (me._updateHashTimeout);
		me._updateHashTimeout = setTimeout (function () {
			// console.log ("updateHash timeout");
			var parentSection;
			var rect;
			var hash;
			var href;
			var lastRect;
			// var firstSection;
			var firstSectionRect;
			$("a.page-anchor").each (function () {
				parentSection = $(this).next ("section, footer");
				// if (!firstSection) firstSection = parentSection[0];
				// if (parentSection) {
				if (parentSection.length) {
					if (!firstSectionRect) firstSectionRect = parentSection [0].getBoundingClientRect ();
					rect = parentSection[0].getBoundingClientRect ();
					// if (rect.y < window.innerHeight / 2 && rect.y + rect.height < window.innerHeight) {
					// 	console.log ("PageHashAnchors", parentSection, "rect", rect);
					// 	// window.location.hash = $(this).prop ("id");
					// 	hash = "#" + $(this).prop ("id");
					// 	return false;
					// }
					//get section with middle closest to middle of the page
					// hash = "#" + $(this).prop ("id");
					if (firstSectionRect.y < window.innerHeight / 2 && rect.y < window.innerHeight) {
						//first section must be higher than half innerHeight
						if (lastRect) {
							var thisRectToMiddle = Math.abs (rect.y + rect.height / 2 - window.innerHeight / 2);
							var lastRectToMiddle = Math.abs (lastRect.rect.y + lastRect.rect.height / 2 - window.innerHeight / 2);
							// console.log (thisRectToMiddle, lastRectToMiddle);
							if (thisRectToMiddle < lastRectToMiddle) {
								// console.log ("YES!", $(this).prop ("id"));
								lastRect = {
									rect: rect,
									hash: "#" + $(this).prop ("id")
								}
							}
						} else {
							// hash = "#" + $(this).prop ("id");
							// console.log ("YES!", $(this).prop ("id"));
							lastRect = {
								rect: rect,
								hash: "#" + $(this).prop ("id")
							};
						}
					} else {
						return false;
					}
				// }
				}
			});
			if (lastRect) hash = lastRect.hash;
			if (hash && hash != me._lastHash) {
				me._lastHash = hash;
				if (history.replaceState) {
					// href = window.location.href.split (window.location.hash).join ("");
					// history.pushState(null, null, href + hash);
					if (window.location.search) {
						history.replaceState(null, null, window.location.pathname + window.location.search + hash);
					} else {
						history.replaceState(null, null, window.location.pathname + hash);
					}
					// console.log (href + hash);
				} else {
					location.hash = hash;
				}
			} else if (!hash) {
				me._lastHash = null;
				if (history.replaceState) {
					if (window.location.search) {
						// history.pushState(null, null, window.location.pathname + window.location.search);
						history.replaceState(null, null, window.location.pathname + window.location.search);
					} else {
						// history.pushState(null, null, window.location.pathname);
						history.replaceState(null, null, window.location.pathname);
					}
				} else {
					var scrollTop = $(window).scrollTop ();
					location.hash = hash;
					$(window).scrollTop (scrollTop);
				}
			}
		}, 250);
	};
	me.init ();
}
	
}) (window);
